module.exports = __webpack_public_path__ + "img/section-3-content_1_t_icon2.4459e241.png";